import React from 'react'
import { Link } from 'react-router-dom'
import { MAIN } from '../../constants/programSectionTypes'
import config from '../../config'
import sectionTypesConfig from '../../program-section-types-config.json'
import DeleteSelectionButton from './DeleteSelectionButton'
import {MASTERMULTICINEMA, MASTERMULTITOTAL} from '../../constants/multiCinemaModes'
import ShowInAppButton from './ShowInAppButton';
import sortCinemas from '../../functions/sortCinemas'
import Translation from '../Translation/cont/Translation'

const SelectionDisplay = ({features, activeSelection, displaySelection, enableDeleteSelection, onUpdateSelectionShowInApp, selection, deleteSelection, cliCinemas, cliMulticinemaMode, onEditSelectionSettings}) => {
    const typeContent = sectionTypesConfig.typeContent
    const { title, filterValue, cinema, cinemasFilter, visibleIn, showInApp, pk } = selection
    const showMultiCinemaOptions = cliMulticinemaMode === MASTERMULTICINEMA || cliMulticinemaMode === MASTERMULTITOTAL ? true : false

    if(!displaySelection) {
        return <p>'Error: No selection found'</p>
    }

    const sortFilteredCinemas = visibleIn ? sortCinemas(cinema, cliCinemas, visibleIn) : cinemasFilter ? sortCinemas(cinema, cliCinemas, cinemasFilter) : null
    const sortedCinemas = sortCinemas(cinema, cliCinemas)
    
    const {selectionPk, type } = displaySelection
    const cinemasArray = sortFilteredCinemas ? sortFilteredCinemas : sortedCinemas
    const cinemasIdsArrayDifference = _.difference(sortedCinemas, cinemasArray)
    const showDeleteSelection = activeSelection ===  title ? false : true
    const isNotMainType = displaySelection.type === MAIN ? false : true
    const typeTransId = typeContent[type] ? typeContent[type].transId : '' 
    let activeTabClass = ''

    const selectionTypeClass = ' ' + type + '-wrapper'
    const filterValueClass = filterValue ? ' ' + filterValue + '-wrapper' : ''
    const hasMcsAppClass = features && features.has_mcs_app ? ' has-mcs-app' : ''

    if (isNotMainType) {
        if (activeSelection ===  title) {
            activeTabClass = "accordion-item-open"
        } else {
            activeTabClass = "accordion-item-close"
        }
    }

    return (
        <div className={"selections-item-wrapper" + selectionTypeClass + filterValueClass + hasMcsAppClass}>
            <div className="button-selection-wrapper odd gap-35">
                {("moviesToday" === filterValue || "moviesTodayByStart" === filterValue || "showtimes" === type) ? (
                    <span className="icon button-edit button-edit-selection button "><span className="screen-reader-text">{title}</span></span>
                ):(
                    <Link className="icon button-edit button-edit-selection button " to={`${config.routes.program.path}/${type}/${selectionPk}`}><span className="screen-reader-text">{title}</span></Link>
                )}
            </div>

            <div className="button-selection-wrapper even gap-35">
                <span className="icon button-edit button-edit-selection-settings button" onClick={() => onEditSelectionSettings(selection.pk)}><span className="screen-reader-text">{'Edit selection settings'}</span></span>
            </div>

            {isNotMainType && <div className="button-selection-wrapper odd gap-35">
                <div className="icon button-move button-move-selection button">
                    <span className="screen-reader-text">Drag and Drop zum Bewegen der Elemente</span>
                </div>
            </div>}

            {enableDeleteSelection && showDeleteSelection && <div className="button-selection-wrapper even gap-35">
                <DeleteSelectionButton
                    title={title}
                    deleteSelection={deleteSelection}
                />
            </div>}
         

            <div className={"selections-item header-" + activeTabClass + ' ' + type}>
                {features && features.has_mcs_app && showInApp !== undefined && <ShowInAppButton pk={pk} type={type} showInApp={showInApp} onUpdateSelectionShowInApp={onUpdateSelectionShowInApp}/>}
                <div className="text-xsmall-light type-name odd gap-35"><Translation id={typeTransId}/></div>
                {visibleIn ? visibleIn.length === 0 && <div className="no-content-alert">
                    <span className="print-title-xlarge">!</span>
                </div>
                : ('')}
                <h3 className="selections-item-title accordion-header site-content-wrapper-inner title-large-light button-selection-wrapper odd gap-35">
                    {("moviesToday" === filterValue || "moviesTodayByStart" === filterValue || "showtimes" === type) ? (
                        <span className="title-large-light ">{title}</span>
                    ):(
                        <Link className="title-large-light " to={`${config.routes.program.path}/${type}/${selectionPk}`}>{title}</Link>
                    )}
                    {showMultiCinemaOptions && isNotMainType ?
                        cinemasIdsArrayDifference.length === 0 && visibleIn && visibleIn.length !== 0 ? (
                            <div className='text-light-description'><Translation id='visible_in_all_cinemas'/></div>
                        ) : (
                            <div className="cinema-acronym-wrapper">
                                {cinemasArray && cinemasArray.map((cinemaId) => {
                                    const cinemaData = cliCinemas[cinemaId]
                                    const {nameShort, pk} = cinemaData
                                    return <p key={pk} className="cinema-acronym text-light-description">{nameShort}</p>
                                })}
                            </div>
                        ) : ('')}
                </h3>
            </div>
        </div>
    )
}

export default SelectionDisplay